import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';

import {LeadsRoutingModule} from './leads-routing.module';
import {LeadsComponent} from './leads.component';
import {LeadDetailComponent} from './lead-detail/lead-detail.component';
import {ContentHeaderModule} from '../../layout/components/content-header/content-header.module';
import {TranslateModule} from '@ngx-translate/core';
import {CoreCommonModule} from '../../../@core/common.module';
import {CardSnippetModule} from '../../../@core/components/card-snippet/card-snippet.module';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {NgSelectModule} from '@ng-select/ng-select';


@NgModule({
    declarations: [LeadsComponent, LeadDetailComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        LeadsRoutingModule,
        ContentHeaderModule,
        TranslateModule,
        CoreCommonModule,
        CardSnippetModule,
        NgxDatatableModule,
        NgbPaginationModule,
        NgSelectModule
    ],
    exports: [LeadsComponent, LeadDetailComponent],
})
export class LeadsModule {
}
